import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import NotificationIcon from '../../../../Icons/24x24/Notification';
import SiteHeaderIconButton from '../SiteHeaderIconButton';
var NotificationCenterButton = function (_a) {
    var className = _a.className, feedbackCount = _a.feedbackCount;
    var t = useTranslation().t;
    return (React.createElement("div", { className: className },
        React.createElement(SiteHeaderIconButton, { icon: NotificationIcon, href: Url.feedbackLink(), ariaLabel: t('siteHeader.a11y.notifications'), count: feedbackCount })));
};
export default NotificationCenterButton;
//# sourceMappingURL=NotificationCenterButton.js.map